import Debt from '../models/Debt';
import Operation, { OperationIntent } from '../models/Operation';
import Saving from '../models/Saving';
import { calculateAmount } from '../random/utils';
import { DebtService } from './DebtService';
import { Container } from '@ivorobioff/shared';
import { SavingService } from './SavingService';

export default class DebtOperationService {
  private debtService: DebtService;
  private savingService: SavingService;

  constructor(container: Container) {
    this.debtService = container.get(DebtService);
    this.savingService = container.get(SavingService);
  }

  validate(debt: Debt, operation: Operation) {
    return calculateAmount(debt.amount, operation) < 0
      ? 'Result must be greater than, or equal to 0'
      : undefined
  }

  async submit(debt: Debt, operation: Operation): Promise<Debt> {
    const calculatedAmount = calculateAmount(debt.amount, operation);

    return this.debtService.updateAmountAsync(debt.id, {
      amount: calculatedAmount,
      note: operation.note,
      version: debt.version
    });
  }

  async payback(debt: Debt, amount: number): Promise<{ saving: Saving; debt: Debt; }> {

    const savings = await this.savingService.getAllAsync();
    const matchedSaving = savings.find(saving => saving.name === debt.name);

    const saving = matchedSaving
      ? matchedSaving
      : await this.savingService.createAsync({
        name: debt.name,
        amount: 0
      });

    await this.savingService.updateAmountAsync(saving.id, {
      amount: calculateAmount(saving.amount, { intent: OperationIntent.Plus, amount }),
      note: `Payback - ${debt.name}`,
      version: saving.version,

    });

    debt = await this.debtService.updateAmountAsync(debt.id, {
      amount: calculateAmount(debt.amount, { intent: OperationIntent.Minus, amount }),
      note: `Payback - ${saving.name}`,
      version: debt.version
    });

    return {
      saving,
      debt
    };
  }
}